// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "ticket-1TYDK";
var _4 = "refund__request-O5y0f";
var _5 = "comments-EI2qA";
var _6 = "button-SjPVs";
var _7 = "reject-2ZZi6";
var _8 = "prices-1HRhh";
var _9 = "step-1NNiU";
export { _1 as "__esModule", _2 as "tablet", _3 as "ticket", _4 as "refund__request", _5 as "comments", _6 as "button", _7 as "reject", _8 as "prices", _9 as "step" }
export default { "__esModule": _1, "tablet": _2, "ticket": _3, "refund__request": _4, "comments": _5, "button": _6, "reject": _7, "prices": _8, "step": _9 }
